import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { LoadingUiService } from './loading-ui.service';

@Component({
    selector: 'app-global-loading',
    standalone: true,
    template: `
        @if (ui.isProgressVisible()) {
            <div class="global-loading-progress" role="progressbar" aria-label="Cargando contenido" aria-valuetext="Cargando">
                <span></span>
            </div>
        }
        @if (ui.isBlocking()) {
            <div class="global-loading-shield" [class.global-loading-shield--visible]="ui.isBlockingVisible()">
                <section class="global-loading-card" role="status" aria-live="polite" aria-label="Cargando información">
                    <div class="global-loading-heading">
                        <img src="/brand/favicon.svg" width="44" height="44" alt="" />
                        <div class="global-loading-copy">
                            <strong>Procesando tu solicitud</strong>
                            <p>Enseguida podrás continuar.</p>
                        </div>
                    </div>
                    <div class="global-loading-track" aria-hidden="true"><span></span></div>
                </section>
            </div>
        }
    `
})
export class GlobalLoadingComponent {
    readonly loading = inject(LoadingService);
    readonly ui = inject(LoadingUiService);
    private readonly navigationReleases = new Map<number, () => void>();

    constructor() {
        const router = inject(Router);
        const destroyRef = inject(DestroyRef);

        destroyRef.onDestroy(() => {
            this.navigationReleases.forEach((release) => release());
            this.navigationReleases.clear();
        });

        router.events.pipe(takeUntilDestroyed(destroyRef)).subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.finishNavigation(event.id);
                this.navigationReleases.set(event.id, this.loading.start('progress'));
                return;
            }

            if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError || event instanceof NavigationSkipped) {
                this.finishNavigation(event.id);
            }
        });
    }

    private finishNavigation(id: number): void {
        this.navigationReleases.get(id)?.();
        this.navigationReleases.delete(id);
    }
}
